// This file contains the default configurations
// But it is not neccessary to upload them to the tenant because if the supplier doesn't
// have the current version of the config and some fields are missing than the default config
// is taken for the missing fields.
//
// Instructions:
// 1. Create a new file named as "ui-config.json"
// 2. Copy this text here and paste it in the file "ui-config.json"
// 3. Delete this part here: "export const defaultConfig =" in the file "ui-config.json"
// 4. Now remove the comments in "ui-config.json" file with this online tool: https://removecomments.com/
// 5. Upload the new config in all tenants
import { DefaultConfig } from '../../data'
import { createDeliveryForecast } from './createDeliveryForecast'
import { createDeliveryForecastDespatchAdvice } from './createDeliveryForecastDespatchAdvice'
import { createDeliveryForecasts } from './createDeliveryForecasts'
import { createDespatchAdvice } from './createDespatchAdvice'
import { createEInvoice } from './createEInvoice'
import { createEInvoiceCockpit } from './createEInvoiceCockpit'
import { createEInvoices } from './createEInvoices/createEInvoices'
import { createInvoice } from './createInvoice'
import { createOrderResponse } from './createOrderResponse'
import { createOrders } from './createOrders'
import { createSelfservices } from './createSelfservices'

// Structure:
// first level --> pages
// second level --> components
// third level --> config for tables, inputs and cards etc.

export const createDefaultConfig = (): DefaultConfig => {
  return {
    deliveryForecasts: createDeliveryForecasts(),
    deliveryForecast: createDeliveryForecast(),
    deliveryForecastDespatchAdvice: createDeliveryForecastDespatchAdvice(),
    orders: createOrders(),
    orderResponse: createOrderResponse(),
    despatchAdvice: createDespatchAdvice(),
    invoice: createInvoice(),
    selfservices: createSelfservices(),
    eInvoices: createEInvoices(),
    eInvoice: createEInvoice(),
    eInvoiceCockpit: createEInvoiceCockpit(),
  }
}
